import type { AdsGeneratedCopy } from "./useAdsResearchStore";

/**
 * Normalize ad copy from the backend or saved artifacts.
 * Handles the rename of imageAdVariants → searchAdVariants and
 * ensures imageOverlayCopy exists (empty array for old artifacts).
 */
export function normalizeAdCopy(raw: any): AdsGeneratedCopy {
  if (!raw || typeof raw !== "object") {
    return { searchAdVariants: [], imageOverlayCopy: [], videoScripts: [] };
  }

  return {
    searchAdVariants: raw.searchAdVariants ?? raw.imageAdVariants ?? [],
    imageOverlayCopy: raw.imageOverlayCopy ?? [],
    videoScripts: raw.videoScripts ?? [],
  };
}
